/*globals $*/
'use strict';

import {validateSaveOtherContractRightForm} from "./validate";

const getValidationFunctions = () => import("./validate");

$( document ).ready(function() {

    /*General*/
    if($('#defaultOpen').length > 0) {
        document.getElementById("defaultOpen").click();
    }


    /*Quan els links a datatable no funciona*/
    $('body').on('click', '[id^="delete_element-"]', function (e) {
        var url = $(this).attr('data-url');
        $('#element_delete_link').attr("href", url);
    });


    /*Bookings*/
    // $('input[name="is_client"]').click(function() {
    //     console.log($(this).val());
    //     if ($(this).val() == 'yes') {
    //         $('#client_select').removeClass('hidden');
    //         $('#no_client').addClass('hidden');
    //
    //     } else {
    //         $('#no_client').removeClass('hidden');
    //         $('#client_select').addClass('hidden');
    //     }
    // });

    $('#checkClientStepBooking').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateClientStepBookingForm();
        });
    });


    $('#backToDatesStepBooking').on('click', function(e){
        e.preventDefault();
        $('#checkDatesStepBooking').removeClass('hidden');
        $('#mini-step_one').removeClass('hidden');
        $('#circle_mini-step_two').removeClass('active');
        $('#mini-step_two').addClass('hidden');
        $('#checkBikesStepBooking').addClass('hidden');
        $('#backToDatesStepBooking').addClass('hidden');
    });

    $('#backToBikesStepBooking').on('click', function(e){
        e.preventDefault();
        $('#checkBikesStepBooking').removeClass('hidden');
        $('#mini-step_two').removeClass('hidden');
        $('#circle_mini-step_three').removeClass('active');
        $('#mini-step_three').addClass('hidden');
        $('#checkDeliveryStepBooking').addClass('hidden');
        $('#backToBikesStepBooking').addClass('hidden');
        $('#backToDatesStepBooking').removeClass('hidden');
    });

    $('#backToDeliveryStepBooking').on('click', function(e){
        e.preventDefault();
        $('#checkDeliveryStepBooking').removeClass('hidden');
        $('#mini-step_three').removeClass('hidden');
        $('#circle_mini-step_four').removeClass('active');
        $('#mini-step_four').addClass('hidden');
        $('#checkConfirmBooking').addClass('hidden');
        $('#backToBikesStepBooking').removeClass('hidden');
        $('#backToDeliveryStepBooking').addClass('hidden');
    });

    $('#checkBikesStepBooking').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateBikesStepBookingForm();
        });
    });

    $('#checkDeliveryStepBooking').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateDeliveryStepBookingForm();
        });
    });

    $('#checkConfirmBooking').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateConfirmBookingForm();
        });
    });



    /*Clients*/
    $('input[name="type"]').change(function() {
        if ($('#type_person').is(':checked')) {
            $('#company_form').addClass('hidden');
        } else {
            $('#company_form').removeClass('hidden');
        }
    });

    let typingTimer;
    const delay = 500;

    $('#postal_code').on('keyup', function() {
        clearTimeout(typingTimer); // Reinicia el temporizador si el usuario sigue escribiendo
            typingTimer = setTimeout(function () {

            let val = $('#postal_code').val();
            if(val) {
                $.ajax({
                    type: "GET",
                    url: '/check/codi_postals/' + val,
                    async: false,
                    success: function (data) {
                        data = JSON.parse(data);
                        if (data) {
                            $('#city').val(JSON.parse(data.name).es);
                        }
                    },

                });
            }
        }, delay);
    });

    $('#checkClient').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateClientForm();
        });
    });


    /*Prices*/
    $('#checkNewPrice').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateNewPriceForm();
        });
    });

    $('#checkPrices').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validatePricesForm();
        });
    });

    /*Accessories*/
    $('#checkAccessory').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateAccessoryForm();
        });
    });


    /*Brands*/
    $('#checkBrand').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateBrandForm();
        });
    });


    /*Categories*/
    $('#checkCategory').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateCategoryForm();
        });
    });


    /*Automatic pedals*/
    $('#checkAutomaticPedal').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateAutomaticPedalForm();
        });
    });


    /*Brakes*/
    $('#checkBrake').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateBrakeForm();
        });
    });


    /*Frames sizes*/
    $('#checkFrameSize').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateFrameSizeForm();
        });
    });


    /*Marches*/
    $('#checkMarch').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateMarchForm();
        });
    });


    /*Wheel size*/
    $('#checkWheelSize').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateWheelSizeForm();
        });
    });


    /*Models*/
    $('#checkModel').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateModelForm();
        });
    });



    /*Calendar*/
    $('#checkCalendar').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateCalendarForm();
        });
    });



    /*Bikes*/

    $('.openMedia').on('click', function(){
        $('#media-info').css('display', 'block');
    });

    $('body').on('click', '[id^="delete_bike_image-"]', function (e) {
        var id = $(this).attr('data-id');
        $('#bike_image_' + id).remove();
        $('#input_image_' + id).remove();

    });

    $('body').on('click', '[id^="delete_image-"]', function (e) {
        var id = $(this).attr('data-id');
        var key = $(this).attr('data-key');
        var bike_id = $('#bike_id').val();

        $.ajax({
            type: "GET",
            url: '/bicicleta/' + bike_id + '/media/eliminar/' + id,
            async: false,
            success: function (data) {
                data = JSON.parse(data);
                console.log(data['response']);
                if (data['response'] == 'success') {
                    $('#bike_image_' + key).remove();
                    $('#input_image_' + key).remove();
                } else {
                    $('#error_message').removeClass('message-hidden');
                    setTimeout(function () {
                        $('#error_message').addClass('message-hidden')
                    }, 60000);
                }
            },

        });

    });

    $('[id^="media-img-"]').on('click', function(){
        $('[id^="media-img-"]').removeClass('img-active');
        $(this).addClass('img-active');
    })

    $('#selectFromGallery').on('click', function(){
        let activeElement = $('[id^="media-img-"].img-active');

        if(activeElement.length > 0) {
            let src  = activeElement.attr('data-url');
            let path = activeElement.attr('data-path') || src;

            let delete_icon = $('#delete-icon').val();
            let lastRow = $('#images tr:last');
            let lastNumber = parseInt(lastRow.find('td:first').text()) || 0;
            let rowCount = lastNumber + 1;

            $('#images').append('<tr id="bike_image_' + rowCount + '">' +
                '<td class="table-index">' + rowCount + '</td>' +
                '<td><div class="image-wrapper"><img src="' + src + '"></div></td>' +
                '<td class="table-action"><img class="table_btn" data-id="' + rowCount + '" id="delete_bike_image-' + rowCount + '" src="' + delete_icon + '"></td>' +
                '</tr>');

            let $targetForm = $('#bike-form').length ? $('#bike-form') : $('#model-form');
            $targetForm.append('<input id="input_image_' + rowCount + '" type="hidden" name="images[]" value="' + path + '">');
            $('#media-info').css('display', 'none');
        }

    });

    $('#btn_media-section-close').on('click', function() {
        $('#media-info').css('display', 'none');
    });

    $('#media-section-close').on('click', function() {
        $('#media-info').css('display', 'none');
    });

    $('#child_seat').change(function() {
        if ($(this).is(':checked')) {
            $('#child_seat_input').removeClass('hidden')
        } else {
            $('#child_seat_input').addClass('hidden')
        }
    });

    $('#helmet').change(function() {
        if ($(this).is(':checked')) {
            $('#helmet_input').removeClass('hidden')
        } else {
            $('#helmet_input').addClass('hidden')
        }
    });

    $('#gps').change(function() {
        if ($(this).is(':checked')) {
            $('#gps_input').removeClass('hidden')
        } else {
            $('#gps_input').addClass('hidden')
        }
    });

    $('#checkBike').on('click', function(e){
        e.preventDefault();
        getValidationFunctions().then(validateModule => {
            validateModule.validateBikeForm();
        });
    });


    $('#pedals').change(function() {
        if ($(this).val() == 'automatic') {
            $('#automatic_pedals_section').removeClass('hidden')
        } else {
            if( !$('#automatic_pedals_section').hasClass('hidden')) {
                $('#automatic_pedals_section').addClass('hidden')
            }
        }
    });
});

